import axios from 'axios'
import { PatientSearchRequest, PatientSearchResponse } from '@/api/services/patient/patient/patient.dto'
import { IResponseAgGrid } from '@/shared/models/ag-grid.model'

class PatientService {
    async getPatients(patientSearchRequest: PatientSearchRequest): Promise<IResponseAgGrid<PatientSearchResponse>> {
        const response = await axios.get<IResponseAgGrid<PatientSearchResponse>>('/patients/search', { params: patientSearchRequest })
        return response.data
    }
}
export const patientService = new PatientService()
